import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBadgeResource } from "../types";

export type IBadgeUpdateMutationParameters = {
    badge: RelationalValue<IBadgeResource>;
    data: {
        name: string;
        template: string;
    };
};

export type IBadgeUpdateMutationResult = IBadgeResource;

export const badgeUpdateMutation: IApiMutationFunction<IBadgeUpdateMutationParameters> = ({ badge, data }) => {
    return {
        method: "PUT",
        url: `/badges/${mapRelationalValue(badge)}`,
        data,
    };
};

export const useBadgeUpdateMutation = createApiMutationHook<IBadgeUpdateMutationParameters, IBadgeUpdateMutationResult>(
    badgeUpdateMutation,
);
